  /*============Footer Controller
        ================================*/
  angular
      .module('vppApp')
      .controller('contactLinksController', contactLinksController);

  contactLinksController.$inject = ['$scope', '$rootScope', 'footerFactory', '$stateParams', 'vppConfig', '$state'];

  function contactLinksController($scope, $rootScope, footerFactory, $stateParams, vppConfig, $state) {
    // Should be filled parameters for each program:
      switch (domainAbbr) {
          case 'gmed':
              $scope.phoneNumber = vppConfig.phoneNumbers.gmed;
              $scope.buyPowerPageParameters = "?media=C5IM099AAX1402004109XXHHX&WT.mc_id=CRS_C_5IM_AA_004109&external_id=CRS_C_5IM_AA_004109&eVar25=VPP_EDU_BUYPOWERCARD_LINKS";
              break;
          case "mpp":
              $scope.phoneNumber = vppConfig.phoneNumbers.mpp;
              $scope.buyPowerPageParameters = "?media=C5IM099AAX1402004109XXHHX&WT.mc_id=CRS_C_5IM_AA_004109&external_id=CRS_C_5IM_AA_004109&eVar25=VPP_MIL_GMCARD_CONTACT_US_LINKS_BPREBRAND";
              break;
          case "cgp":
              $scope.phoneNumber = vppConfig.phoneNumbers.cgp;
              $scope.buyPowerPageParameters = "?media=C5IM099AAX1402004109XXHHX&WT.mc_id=CRS_C_5IM_AA_004110&external_id=CRS_C_5IM_AA_004110&eVar25=VPP_COL_BUYPOWERCARD_LINKS";
              break;
          case "ded":
              $scope.phoneNumber = vppConfig.phoneNumbers.ded;
              $scope.buyPowerPageParameters = "?media=C5IM099AAX1402004109XXHHX&WT.mc_id=CRS_C_5IM_AA_004109&external_id=CRS_C_5IM_AA_004109&eVar25=VPP_DLR_BUYPOWERCARD_LINKS";
              break;
          case "emp": 
              $scope.phoneNumber = vppConfig.phoneNumbers.emp;
              $scope.buyPowerPageParameters = "?media=C5IM099AAX1402004109XXHHX&WT.mc_id=CRS_C_5IM_AA_004109&external_id=CRS_C_5IM_AA_004109&eVar25=VPP_FF_BUYPOWERCARD_LINKS";
              break;
          case "sup":
              $scope.phoneNumber = vppConfig.phoneNumbers.sup;
              $scope.buyPowerPageParameters = "?media=C5IM099AAX1402004109XXHHX&WT.mc_id=CRS_C_5IM_AA_004110&external_id=CRS_C_5IM_AA_004110&eVar25=VPP_SUPP_BUYPOWERCARD_LINKS";
              break;
          case "frd":
              $scope.phoneNumber = vppConfig.phoneNumbers.frd;
              //$scope.buyPowerPageParameters = "?media=C5IM099AAX1402004109XXHHX&WT.mc_id=CRS_C_5IM_AA_004110&external_id=CRS_C_5IM_AA_004110&eVar25=VPP_SUPP_BUYPOWERCARD_LINKS";
              break;
          default:
              $scope.phoneNumber = null;
              $scope.buyPowerPageParameters = null;
      }
  };
